import { SESSION_GLOBAL_RESET } from './types';

export default (existingSessionToKeep, shouldKeepSlotBooking = true) => ({
  existingSessionToKeep,
  shouldKeepSlotBooking,
  type: SESSION_GLOBAL_RESET,
});
